// Same enum on backend
export enum FeedbackType {
  MarketActivity = 1,
  Rieltors = 2,
  Objects = 3,
  IosAppReview = 4,
  AndroidAppReview = 5,
  FopIbanReview = 6,
  Dashboard = 7,
  OffersManagement = 8,
  Stats = 9,
  Deals = 10,
  Agents = 11,
  ProSubscription = 12,
  ProfileSummary = 13,
  ActivityFeed = 14
}
